import log from 'salvo-lite/log'

import ProductModal from '../components/ProductModal'

class pageCollections {
    constructor (components) {
        this._components = components
        this._collectionBlocks = document.querySelectorAll('.collection-block')
    }

    onInit () {
        log.debug('pageCollections', 'Initiated', this)
        if (this._collectionBlocks.length > 0) {
            this.triggerSliders()
        }
    }

    triggerSliders () {
        this.sliders = {}
        for (var i = 0; i < this._collectionBlocks.length; i++) {
            let idx = 'collectionSlider-' + i
            this.sliders[idx] = this._components.getComponentsById(idx)
            this.sliders[idx]._elem.addEventListener('initiated', e => {
                for (let slide of this.sliders[idx]._slides) {
                    if (slide.productModal) continue
                    slide.productModal = new ProductModal(window.__theme, slide)
                    slide.productModal.onInit()
                }
            })
            this.sliders[idx].init()
        }
    }
}

export default pageCollections



// WEBPACK FOOTER //
// ./src/scripts/pages/pageCollections.js